export const apiField = 'seismic_sds';

interface SeismicSdsField {
  type: string;
  label: string;
  apiField: string;
  tooltip: () => string;
  missing?: any;
  min?: number;
  max?: number;
}

const config: SeismicSdsField = {
  type: 'Number',
  label: 'seismic_sds',
  apiField,
  tooltip: () => "Seismic Conditions: The changing or dynamic lateral load due to earthquake activity. For arrays located in seismic areas, the design of the support structure should resist the additional horizontal load.",
  missing: undefined,
  min: 0.01,
  max: 3.1,
};

export default config;
